import moment from "moment";
import React, { useEffect, useState } from "react";
import CardLayout from "../../../../common/cardLayout/CardLayout";

const TableBodyStructure = ({ data }) => {
  let styleBlue = {
    color: "#1E90FF",
  };
  if (data["label"].includes("Action")) {
    styleBlue = {
      color: "gray",
    };
  }
  let StyleGreen = {
    color: "",
  };
  return (
    <tr>
      <th scope="row" style={styleBlue}>
        {data["label"]}
      </th>
      {Object.values(data).map((item, index) => {
        if (index < 7) {
          let value = item ? item : "-";
          if (value === true) {
            value = "Yes";
            StyleGreen = {
              color: "green",
            };
          }
          return <td style={StyleGreen}>{value}</td>;
        }
      })}
    </tr>
  );
};

const DBTTable = (props) => {
  //console.log("props", props);
  const [data, setData] = useState(props.dbtData);
  const [hColumns, sethColumns] = useState([]);
  useEffect(() => {
    if (props?.dbtData) {
      setData(props.dbtData);
    }
  }, [props.dbtData]);
  useEffect(() => {
    const hColumns = [];
    const endDate = moment(props.dbtEndDate);
    const duration = endDate.diff(props.dbtStartDate, "days");
    for (let i = 0; i <= duration; i++) {
      const currentDay = moment(props.dbtStartDate).add(i, "days");
      const dayDate = currentDay.format("YYYY-MM-DD");
      const dayName = currentDay.format("ddd");
      const col = { id: i, dayName: dayName, dayDate: dayDate };
      hColumns.push(col);
      sethColumns(hColumns);
    }
  }, [props.dbtStartDate]);

  return (
    <CardLayout
      className="col-sm-12 col-md-12 col-lg-12"
      style={{
        border: "8px solid transparent",
        boxSizing: "border-box",
        backgroundClip: "padding-box",
      }}
    >
      <div className="row col-sm-12 col-md-12 col-lg-12">
        <h4 style={{ textAlign: "left" }}>{props.name}</h4>
      </div>
      <table className="table my-3 px-2">
        <thead className="thead-light" style={{ backgroundColor: "#C8E1EC" }}>
          <tr
            style={{
              height: "4rem",
              verticalAlign: "middle",
            }}
          >
            <th scope="col">
              <span className="muted-text"></span>
            </th>
            {hColumns.map((col) => {
              return (
                <th scope="col" key={col.id}>
                  <div>
                    <span>{col.dayName}</span>
                  </div>
                  <div>
                    <span>{col.dayDate}</span>
                  </div>
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {data?.map((item) => {
            return <TableBodyStructure data={item} />;
          })}
        </tbody>
      </table>
    </CardLayout>
  );
};

export default DBTTable;
